var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Overall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-&-pop-up-&-button",
    transform: "translate(-353.000000, -1704.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(353.000000, 1704.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#007AF0",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5263158,16.6160714 L22.5263158,27.8125 C22.5257719,28.4680475 22.113721,28.9992988 21.6052631,29 L18.1842105,29 C17.6757527,28.9992988 17.2637018,28.4680475 17.2631579,27.8125 L17.2631579,16.6160714 C17.2637018,15.960524 17.6757527,15.4292727 18.1842105,15.4285714 L21.6052631,15.4285714 C22.113721,15.4292727 22.5257719,15.960524 22.5263158,16.6160714 Z M28.868421,10 L25.4473684,10 C24.9389106,10.0007012 24.5268597,10.5319525 24.5263158,11.1875 L24.5263158,27.8125 C24.5268597,28.4680475 24.9389106,28.9992988 25.4473684,29 L28.868421,29 C29.3768789,28.9992988 29.7889298,28.4680475 29.7894737,27.8125 L29.7894737,11.1875 C29.7889298,10.5319525 29.3768789,10.0007012 28.868421,10 L28.868421,10 Z M14.3421053,19.5 L10.9210526,19.5 C10.4125948,19.5007013 10.0005439,20.0319526 10,20.6875 L10,27.8125 C10.0005439,28.4680475 10.4125948,28.9992988 10.9210526,29 L14.3421053,29 C14.8505631,28.9992988 15.262614,28.4680475 15.2631579,27.8125 L15.2631579,20.6875 C15.262614,20.0319526 14.8505631,19.5007013 14.3421053,19.5 L14.3421053,19.5 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsOverview);
export default __webpack_public_path__ + "static/media/stats-overview.2ff2354669a43ccee89ea64f5a256b35.svg";
export { ForwardRef as ReactComponent };